import { useEffect, useRef, useState, useCallback } from 'react';

const activityEvents = [
    'mousedown',
    'keydown',
    // Add more events if needed: 'mousemove', 'touchstart', 'scroll'
];

const useUserActivity = (
    timeoutSeconds: number = 60,
    enabled: boolean = true
): [boolean, () => void] => {
    const [isActive, setIsActive] = useState(true);
    const timer = useRef<number | null>(null);

    const resetTimer = useCallback(() => {
        setIsActive(true);
        console.log('User activity detected, resetting timer');
        if (timer.current) clearTimeout(timer.current);
        timer.current = window.setTimeout(() => {
            setIsActive(false);
            console.log(`User inactive for ${timeoutSeconds} seconds, setting isActive to false`);
        }, timeoutSeconds * 1000);
    }, [timeoutSeconds]);

    useEffect(() => {
        if (!enabled) {
            setIsActive(true);
            if (timer.current) clearTimeout(timer.current);
            activityEvents.forEach((event) => window.removeEventListener(event, resetTimer));
            return;
        }

        activityEvents.forEach((event) => window.addEventListener(event, resetTimer));
        resetTimer();

        return () => {
            activityEvents.forEach((event) => window.removeEventListener(event, resetTimer));
            if (timer.current) clearTimeout(timer.current);
        };
    }, [resetTimer, enabled]);

    return [isActive, resetTimer];
};

export default useUserActivity;
